import { HeaderConfig } from '../../_models/header-config.model';
import { SidenavConfig } from '../../_models/sidenav-config.model';

/**
 * A class to store sidenav layout configuration data
 */
export class SidenavLayoutConfig {
  /** A header config object */
  public header: HeaderConfig = new HeaderConfig();

  /** A sidenav config object */
  public sidenav: SidenavConfig = new SidenavConfig();
}
